'use client'

import { Children, isValidElement, type ReactNode } from 'react'
import {
  Carousel,
  CarouselControls,
  CarouselItem,
  CarouselItemNav,
  CarouselItems,
  CarouselNextButton,
  CarouselPreviousButton,
} from '@/components/elementary/carousel/Carousel'

type ReviewCardsListMobileCarouselProps = {
  readonly children: ReactNode
}

export function ReviewCardsListMobileCarousel({ children }: ReviewCardsListMobileCarouselProps) {
  return (
    <Carousel className="relative">
      <CarouselItems className="rounded-xl">
        {Children.map(children, (child) =>
          isValidElement(child) ? (
            <CarouselItem key={child.key} className="rounded-xl">
              {child}
            </CarouselItem>
          ) : null,
        )}
      </CarouselItems>

      <CarouselControls className="absolute w-full justify-between -bottom-12 rounded-xl py-2 px-4 gap-7">
        <CarouselPreviousButton className="shadow-none bg-transparent [&_svg]:size-5 p-0" />
        <CarouselItemNav activeColor="neutral-light-600" />
        <CarouselNextButton className="shadow-none bg-transparent [&_svg]:size-5 p-0" />
      </CarouselControls>
    </Carousel>
  )
}
